// Module
var code = "<div class=\"row\"> <div class=\"answer col-12 mb-1\"> <div class=\"mine messages\"> <div class=\"message last\"><span class=\"content-question\">This is a question</span></div> </div> </div> </div> ";
// Exports
module.exports = code;